<template>
  <div class="main">
    <div style="display: flex; justify-content: space-between; margin-bottom: 20px">
    </div>
    <div>
      <a-table :columns="warehouseColumns" :data-source="tableWarehouseData" :loading="tableLoading"
        :pagination="pagination" class="tableStyle">
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
        <template slot="action" slot-scope="data">
          <a-dropdown>
            <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon style="font-size: 25px" type="ellipsis" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showWareDetails(data)">View More?</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="statusLabel" slot-scope="data">
          <span v-if="data">
            <status-component :status="data"></status-component>
          </span>
          <span v-else>N/A</span>
        </template>
      </a-table>
    </div>

    <!-- <a-modal
            class="modalStyle"
            :visible="addSupplierVisible"
            :footer="null"
            @cancel="handleAddSupplierCancel"
            >
                    
                    <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">Add Supplier</p>
                    <div>
                        <a-form-model
                            ref="addSupplierForm"
                            :model="addSupplierModel"
                            :rules="rules"
                        >
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Supplier Name" ref="supplierName" prop="supplierName">
                                    <a-input
                                        class=""
                                        v-model="addSupplierModel.supplierName"
                                    />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Supplier Address" ref="supplierAddress" prop="supplierAddress">
                                    <a-input
                                        class=""
                                        v-model="addSupplierModel.supplierAddress"
                                    />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Supplier Phone Number" ref="supplierPhoneNumber" prop="supplierPhoneNumber">
                                    <a-input
                                        class=""
                                        v-model="addSupplierModel.supplierPhoneNumber"
                                    />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Supplier Description" ref="supplierDescription" prop="supplierDescription">
                                    <a-input
                                        class=""
                                        v-model="addSupplierModel.supplierDescription"
                                    />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        
                       
                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleAddSupplierSubmit" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add Supplier
                            </a-button>
                        </a-form-model-item>

                        </a-form-model>
                    </div>
            </a-modal> -->
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import StatusComponent from "@/components/shared-components/StatusComponent.vue";


const warehouseColumns = [
  {
    title: "Warehouse ID",
    // width: 150,
    key: "id",
    dataIndex: "id",
  },
  {
    title: "Warehouse Name",
    // width: 150,
    key: "name",
    dataIndex: "name",
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
  {
    title: "Warehouse Address",
    // width: 150,
    key: "address",
    dataIndex: "address",
  },
  {
    title: "Created At",
    // width: 150,
    key: "createdAt",
    dataIndex: "createdAt",
  },
  {
    title: "Status",
    dataIndex: "statusLabel",
    key: "statusLabel",
    scopedSlots: { customRender: "statusLabel" },
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "Warehouse",
  components: {
    StatusComponent
  },
  data() {
    return {
      tableWarehouseData: [],
      tableLoading: false,
      warehouseColumns,
      pagination: {
        pageSize: 20,
      },
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {},
      },
      addSupplierModel: {
        supplierName: "",
        supplierAddress: "",
        supplierPhoneNumber: "",
        supplierDescription: "",
      },

      addSupplierVisible: false,
      dateFormat: "DD/MM/YYYY",
      startDate: moment(),
      endDate: moment(),
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      loading: false,
      rules: {
        notes: [
          {
            required: true,
            message: "Please this field cannot be empty",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],

        manufacturerName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        manufacturerDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        supplierName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        supplierAddress: [
          {
            required: true,
            message: "Please enter address",
            trigger: "change",
          },
        ],
        supplierPhoneNumber: [
          {
            required: true,
            message: "Please enter phone number",
            trigger: "change",
          },
        ],
        supplierDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        categoryName: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        categoryDescription: [
          {
            required: true,
            message: "Please enter description",
            trigger: "change",
          },
        ],
        categoryGroup: [
          {
            required: true,
            message: "Please select your option",
            trigger: "change",
          },
        ],
        isRestricted: [
          {
            required: true,
            message: "Please select your option",
            trigger: "change",
          },
        ],
        categoryCommission: [
          {
            required: true,
            message: "Please enter commission",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["IsAgentProfileAvailable"]),
  },
  methods: {
    ...mapActions([
      "getAllWarehousesData",
      "setWareHouseInfo",
      "updateProductSupplier",
    ]),
    onChange(date, dateString) {
      // console.log(date, dateString);
      this.startDate = dateString[0];
      this.endDate = dateString[1];
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
    },
    moment,

    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
        this.getAllWarehouses()
    },

    showSupplierModal() {
      this.addSupplierVisible = true;
    },
    supplierOnChange(checked) {
      this.isSupplierEnabled = checked;
    },
    showWareDetails(data) {
      this.setWareHouseInfo(data);
      this.$router
        .push({
          name: "warehouse-details",
          params: { id: data.id },
        })
        .catch(() => {});
    },

    handleAddSupplierCancel() {
      this.addSupplierVisible = false;
    },
    handleAddSupplierSubmit() {
      this.$refs.addSupplierForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const request = {
            name: this.addSupplierModel.supplierName,
            address: this.addSupplierModel.supplierAddress,
            metadata: {
              phoneNumber: this.addSupplierModel.supplierPhoneNumber,
              description: this.addSupplierModel.supplierDescription,
            },
            status: 1,
          };

          this.addProductSupplier(request).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.getProductsMgtData();
                this.showSuccessAlert("Supplier Added Successfully");
                this.addSupplierVisible = false;
                this.$refs.addSupplierForm.resetFields();
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },

    getAllSuppliersData(response) {
      if (response.status === 200) {
        this.tableWarehouseData = response.data.data.map((supplier) => ({
          id: supplier.id,
          key: supplier.id,
          name: supplier.name,
          address: supplier.address ? supplier.address : "N/A",
          status: supplier,
          isRestricted: supplier.isRestricted === true ? "Yes" : "No",
          dateCreated: moment(supplier.createdAt).format("DD-MM-YYYY"),
          action: supplier,
        }));
        // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
      } else {
        // // console.log("Error | ", response);
      }
    },
    async getAllWarehouses() {
      this.tableLoading = true;
      const response = await this.getAllWarehousesData();
      this.tableLoading = false;
      if (response.status === 200) {
        this.tableWarehouseData = response.data.data.map((warehouse) => ({
          key: warehouse.id,
          id: warehouse.id,
          name: warehouse.name,
          address: warehouse.address ? warehouse.address : "N/A",
          createdAt: moment(warehouse.createdAt).format("DD-MM-YYYY"),
          action: warehouse,
        }));
        // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
      } else {
        // // console.log("Error | ", response);
      }
    },
  },
  created() {
    if (this.getAllWarehouses) {
      this.getAllWarehouses();
    }
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
}
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}
.tableStyle >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
  color: #fff;
}
.tableStyle >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}
a {
  color: #418a49;
}
a:hover {
  color: #418a49;
}
button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}

button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.tableStyle >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.ant-switch-checked {
  background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>